const REFERRAL_STORAGE_KEY = 'referral_code';
const REFERRAL_TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 days

interface StoredReferral {
    code: string;
    expiresAt: number;
}

export const saveReferralCode = (code: string): void => {
    if (!code) return;
    const payload: StoredReferral = {
        code,
        expiresAt: Date.now() + REFERRAL_TTL_MS,
    };
    localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(payload));
};

export const getReferralCode = (): string | null => {
    const raw = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!raw) return null;

    try {
        const { code, expiresAt }: StoredReferral = JSON.parse(raw);
        if (!code || !expiresAt || Date.now() > expiresAt) {
            localStorage.removeItem(REFERRAL_STORAGE_KEY);
            return null;
        }
        return code;
    } catch {
        localStorage.removeItem(REFERRAL_STORAGE_KEY);
        return null;
    }
};

// Reads `?ref=` from the current URL, if present, and persists it for 60 days
// so it can be reused on a later visit even if the param is gone.
export const captureReferralCodeFromUrl = (search: string): void => {
    const ref = new URLSearchParams(search).get('ref');
    if (ref) saveReferralCode(ref);
};
